import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function ExecutionMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-slate-50">
      <div className="bg-white border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Dashboard Giám Sát Sản Xuất (Real-time)
        </span>
        <span className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
          <span className="text-slate-500 text-[10px]">Cập nhật: Vừa xong</span>
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col overflow-auto">
        <div className="grid grid-cols-2 gap-4 mb-4">
          {/* Máy In 1 */}
          <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-green-500 text-white text-[9px] px-2 py-0.5 rounded-bl font-bold">
              RUNNING
            </div>
            <h4 className="font-bold text-slate-800 text-xs md:text-sm mb-2">
              Máy In Komori G40
            </h4>
            <div className="flex justify-between items-end mb-2">
              <div>
                <div className="text-[10px] text-slate-500">
                  Tốc độ hiện tại
                </div>
                <div className="text-xl font-bold text-slate-800">
                  12,500{" "}
                  <span className="text-[10px] font-normal text-slate-500">
                    tờ/giờ
                  </span>
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] text-slate-500">
                  Tiến độ Lệnh #089
                </div>
                <div className="text-sm font-bold text-indigo-600">
                  8,500 / 10,100
                </div>
              </div>
            </div>
            <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-indigo-500 w-[84%]"></div>
            </div>
          </div>
          {/* Máy Bế 1 */}
          <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-amber-500 text-white text-[9px] px-2 py-0.5 rounded-bl font-bold">
              SETUP
            </div>
            <h4 className="font-bold text-slate-800 text-xs md:text-sm mb-2">
              Máy Bế Tự Động Bobst
            </h4>
            <div className="flex justify-between items-end mb-2">
              <div>
                <div className="text-[10px] text-slate-500">Trạng thái</div>
                <div className="text-sm font-bold text-amber-600">
                  Đang lên khuôn
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] text-slate-500">
                  Tiến độ Lệnh #085
                </div>
                <div className="text-sm font-bold text-slate-400">
                  0 / 5,000
                </div>
              </div>
            </div>
            <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-amber-500 w-[5%] animate-pulse"></div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-slate-200 shadow-sm flex-1 p-3">
          <h4 className="text-xs font-bold text-slate-700 mb-3">
            Nhật ký Báo cáo Sản lượng (Ca Ngày)
          </h4>
          <div className="space-y-2">
            <div className="flex justify-between items-center text-[10px] md:text-xs border-b border-slate-100 pb-2">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center font-bold text-[9px] text-slate-600">
                  NV
                </div>
                <div>
                  <div className="font-bold text-slate-800">
                    Nguyễn Văn A{" "}
                    <span className="font-normal text-slate-500">
                      (Máy Dán)
                    </span>
                  </div>
                  <div className="text-slate-500 text-[9px]">
                    Lệnh #080: Hộp Bánh Trung Thu
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="font-bold text-emerald-600">+ 2,500 hộp</div>
                <div className="text-slate-400 text-[9px]">10:15 AM</div>
              </div>
            </div>
            <div className="flex justify-between items-center text-[10px] md:text-xs border-b border-slate-100 pb-2 opacity-70">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center font-bold text-[9px] text-slate-600">
                  TB
                </div>
                <div>
                  <div className="font-bold text-slate-800">
                    Trần Bình{" "}
                    <span className="font-normal text-slate-500">(Máy In)</span>
                  </div>
                  <div className="text-slate-500 text-[9px]">
                    Lệnh #089: Cấp giấy lần 1
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="font-bold text-blue-600">+ 5,000 tờ</div>
                <div className="text-slate-400 text-[9px]">09:30 AM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-900 text-slate-200">
      <div className="p-4 bg-slate-800 border-b border-slate-700 flex justify-between items-center z-10 sticky top-0 shadow-md">
        <div>
          <div className="text-[10px] text-slate-400 font-medium">
            Ca Ngày - Máy In Komori
          </div>
          <div className="text-sm font-bold text-white">Báo Cáo Sản Lượng</div>
        </div>
      </div>

      <div className="flex-1 p-4 flex flex-col gap-4">
        <div className="bg-slate-800 p-4 rounded-xl border border-slate-700 shadow-md text-center">
          <div className="text-xs text-slate-400 mb-1">Lệnh đang chạy</div>
          <div className="text-lg font-bold text-indigo-400 mb-4">#PO-089</div>

          <div className="text-5xl font-light text-white mb-4">
            8,500<span className="text-lg text-slate-500 ml-1">/10k</span>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <button className="bg-slate-700 text-white py-3 rounded-lg text-xl font-bold shadow-sm active:bg-slate-600">
              +100
            </button>
            <button className="bg-indigo-600 text-white py-3 rounded-lg text-xl font-bold shadow-md shadow-indigo-900 active:bg-indigo-500">
              +500
            </button>
          </div>
        </div>

        <div className="bg-slate-800 p-3 rounded-xl border border-slate-700 shadow-md">
          <div className="text-xs font-bold text-slate-300 mb-2 border-b border-slate-700 pb-2">
            Báo Phế Phẩm (NCR)
          </div>
          <div className="flex gap-2">
            <input
              type="number"
              placeholder="Nhập số lượng lỗi..."
              className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-xs text-white placeholder-slate-500"
            />
            <button className="bg-red-900/50 text-red-400 border border-red-900 px-4 rounded-lg text-xs font-bold hover:bg-red-900/70">
              Báo Lỗi
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
